var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { sleep } from "../../common";
import { IBrushType } from "../../common/enums/PenEnums";
import { ByteConverter } from "./ByteConverter";
import { OfflineDataInfo } from "./OfflineDataInfo";
import { deviceSelectDlg, PenCommBase } from "./pencomm_base";
import { Cmd, PenProfile, SettingType } from "./pencomm_cmd";
import { DEFAULT_MAX_FORCE, DEFAULT_PASSWORD, PEN_PACKET_END, PEN_PACKET_START } from "./pencomm_const";
import { DeviceTypeEnum } from "./pencomm_enum";
import { makePenEvent, PenCommEventEnum } from "./pencomm_event";
import { OfflineDataResultType, processOfflinePacketReceived_main } from "./pencomm_offlinedata";
import { Packet } from "./pen_packet";
import { decimalToHex, getSectionOwnerBytes, int16ToBytes, int32ToBytes, int64ToBytes, intFromBytes, strFromBytes, toUTF8Array } from "./pen_util_func";
// import { NeoSmartpen } from "./neosmartpen";
export var PenUsbMode;
(function (PenUsbMode) {
    PenUsbMode["DISK"] = "disk";
    PenUsbMode["BULK"] = "bulk";
})(PenUsbMode || (PenUsbMode = {}));
export function penTipModeToBrushType(penTipMode) {
    return penTipMode === 0 ? IBrushType.PEN : IBrushType.ERASER;
}
/**
 * protocol handshake duration in ms, while Handshaking
 */
const protocolTimeoutLimit = 1000;
export function strokeTypeToBrushType(strokeType) {
    if (strokeType === 0)
        return IBrushType.PEN;
    if (strokeType === 1)
        return IBrushType.MARKER;
    return IBrushType.ERASER;
}
export function brushTypeToStrokeType(brushType) {
    if (brushType === IBrushType.PEN)
        return 0;
    if (brushType === IBrushType.MARKER)
        return 1;
    return 0;
}
const bufferArray_first = new Uint8Array([
    PEN_PACKET_START,
    // cmd (1)
    Cmd.VERSION_REQUEST,
    // length (2)
    0x2a, 0x00,
    // connection code (16)
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
    // app type (2)
    0x00, 0x00,
    // app version (16)
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
    // protocol version(8) 2.18
    0x32, 0x2e, 0x31, 0x38, 0x00, 0x00, 0x00, 0x00,
    PEN_PACKET_END,
]); // end packet
// /**
//  *
//  * @param {number} typeNumber - 0:pen, 1:eraser, 2:player, on 2020/10/01
//  * @return {DeviceTypeEnum} - a member of DeviceTypeEnum
//  */
// function getPenType(typeNumber): DeviceTypeEnum {
//   let result = DeviceTypeEnum.PEN;
//   switch (typeNumber) {
//     case 0:
//       result = DeviceTypeEnum.PEN;
//       break;
//     case 1:
//       result = DeviceTypeEnum.ERASER;
//       break;
//     case 2:
//       result = DeviceTypeEnum.PLAYER;
//       break;
//     default:
//       result = DeviceTypeEnum.PEN;
//       console.error(`device type mismatch (not 0, 1, neither 2), Pen type from pen is ${typeNumber}`);
//       break;
//   }
//   return result;
// }
// export default class PenComm implements ProtocolHandlerBase {
export default class PenComm {
    /* #endregion */
    constructor(penHandler) {
        this.btDevice = null;
        // device information
        this.deviceInfo = {
            /** @type {string} */
            modelName: "",
            /** @type {number} */
            protocolVer: 100,
            /** @type {DeviceTypeEnum} */
            deviceType: DeviceTypeEnum.NONE,
            /** @type {string} */
            mac: "00:00:00:00:00:00",
        };
        this.isPenDown = false;
        this._shouldProcessReqOnlineData = false;
        this._requestOnlineDataOnConencted = false;
        /* #region  for process Offline data , 2022/05/17 */
        this.PenMaxForce = DEFAULT_MAX_FORCE + 1;
        this.reCheckPassword = false;
        this.onConnectingProtocolTimeout = () => {
            var _a;
            if (this.isNowConnecting) {
                (_a = this._connectionTask) === null || _a === void 0 ? void 0 : _a.resolve(false);
                this._connectionTask = {};
            }
        };
        // 2022/06/27
        this.clearProtocolTimeout = () => {
            if (this._connectionTask.timer !== undefined && this._connectionTask.timer !== null) {
                window.clearTimeout(this._connectionTask.timer);
            }
        };
        // 2022/06/27
        this.setProtocolTimeout = (status) => {
            console.log(status);
            this._connectionTask.status = status;
            this.clearProtocolTimeout();
            this._connectionTask.timer = window.setTimeout(() => {
                this.onConnectingProtocolTimeout();
            }, protocolTimeoutLimit);
        };
        this.setTimeStamp = (value) => {
            this._currentTime = value;
            this._strokeStartTime = value;
        };
        this.accTime = (delta) => {
            this._currentTime = this._currentTime + delta;
        };
        this.getMac = () => {
            return this.deviceInfo.mac;
        };
        this.getModelName = () => {
            return this.deviceInfo.modelName;
        };
        this.getProtocolVer = () => {
            return this.deviceInfo.protocolVer;
        };
        /**
         * @public
         * @return {BluetoothDevice}
         */
        this.getBtDevice = () => {
            return this.btDevice;
        };
        this._connectionTask = {};
        /**
         *
         *
         * @param {BluetoothDevice} btDevice
         * @memberof PenComm
         */
        this.connect = (btDevice, requestOnlineData) => {
            this.btDevice = btDevice;
            this._requestOnlineDataOnConencted = requestOnlineData;
            const promise = new Promise((resolve, reject) => {
                this._connectionTask.resolve = resolve;
                this._connectionTask.reject = reject;
            });
            this._connectionTask.promise = promise;
            this.penCommBase.connect(btDevice, this.onPhysicallyConnected).then((ret) => {
                if (!ret.success) {
                    console.log(`connection failed physically: ${ret.status}`);
                    console.error(`connection failed physically: ${ret.status}`);
                    window.setTimeout(() => {
                        this.clearProtocolTimeout();
                        this._connectionTask.resolve(false);
                        this._connectionTask = {};
                    }, 50);
                }
            });
            return this._connectionTask.promise;
        };
        this.disconnect = () => {
            this.penCommBase.disconnect();
        };
        this.writeArray = (bf) => __awaiter(this, void 0, void 0, function* () {
            return yield this.penCommBase.writeArray(bf);
        });
        this.write = (buf) => __awaiter(this, void 0, void 0, function* () {
            return yield this.penCommBase.write(buf);
        });
        this.onDisconnected = () => {
            // if connection on progress, 2022/06/27
            if (this.isNowConnecting) {
                console.log(`physically disconnected during finding services`);
                console.error(`physically disconnected during finding services`);
                // this._connectionTask?.resolve(false);
                // this._connectionTask = {};
            }
            else {
                const e = makePenEvent(this.deviceInfo.deviceType, PenCommEventEnum.ON_DISCONNECTED, { timeStamp: this.currentTime });
                this.penHandler.onDisconnected(e);
            }
        };
        // 2022/05/10
        this.process_62_shutdown_event = () => {
            const e = makePenEvent(this.deviceInfo.deviceType, PenCommEventEnum.ON_SHUTDOWN_EVENT, { timeStamp: this.currentTime });
            this.penHandler.onShutdownEvent(e);
        };
        this.process_61_low_battery_event = () => {
            const e = makePenEvent(this.deviceInfo.deviceType, PenCommEventEnum.ON_LOW_BATTERY_EVENT, { timeStamp: this.currentTime });
            this.penHandler.onLowBatteryEvent(e);
        };
        this.reqVersion_01 = () => {
            // CMD 0x01
            this.write(bufferArray_first);
        };
        this.reqPassword_02 = (passcode) => {
            if (passcode == null)
                return;
            if (passcode == DEFAULT_PASSWORD)
                return;
            this.newPassword = passcode;
            const passBytes = toUTF8Array(passcode, 16);
            const bf = [
                PEN_PACKET_START,
                Cmd.PASSWORD_REQUEST,
                0x10, 0x00,
                ...passBytes,
                PEN_PACKET_END
            ];
            this.writeArray(bf);
        };
        this.reqSetUpPassword_03 = (oldPassword, newPassword = "") => {
            if (oldPassword == null || newPassword == null)
                return false;
            if (oldPassword === DEFAULT_PASSWORD)
                return false;
            if (newPassword === DEFAULT_PASSWORD)
                return false;
            this.newPassword = newPassword;
            const oldBytes = toUTF8Array(oldPassword, 16);
            const newBytes = toUTF8Array(newPassword, 16);
            const bf = [
                PEN_PACKET_START,
                Cmd.PASSWORD_CHANGE_REQUEST,
                33, 0x00,
                newPassword === "" ? 0 : 1,
                ...oldBytes,
                ...newBytes,
                PEN_PACKET_END
            ];
            this.writeArray(bf);
            return true;
        };
        this.reqConfig_04 = () => {
            // CMD 0x04, 펜 설정을 확인하는 패킷을 보낸다. request pen status
            const bf = [
                PEN_PACKET_START,
                Cmd.SETTING_INFO_REQUEST,
                0x00, 0x00,
                PEN_PACKET_END
            ];
            this.writeArray(bf);
        };
        this.reqChangeSetting_05 = (type, value) => {
            /**
             *  0:  1 - header
             *  1:  1 - cmd (0x05)
             *  2:  2 - length (0x02)
             *  4:  1 - attribute type (SettingType)
             *  5:  n - value
             */
            const bf = [
                PEN_PACKET_START,
                Cmd.SETTING_CHANGE_REQUEST, // 0x05,
            ];
            let tmp;
            switch (type) {
                case SettingType.Timestamp:
                    bf.push(...int16ToBytes(9));
                    bf.push(type);
                    bf.push(...int64ToBytes(value));
                    break;
                case SettingType.AutoPowerOffTime:
                    bf.push(...int16ToBytes(3));
                    bf.push(type);
                    bf.push(...int16ToBytes(value));
                    break;
                case SettingType.LedColor:
                    bf.push(...int16ToBytes(5));
                    bf.push(type);
                    tmp = int32ToBytes(value);
                    bf.push(...[tmp[3], tmp[2], tmp[1], tmp[0]]);
                    break;
                case SettingType.PenCapOff:
                case SettingType.AutoPowerOn:
                case SettingType.Beep:
                case SettingType.Hover:
                case SettingType.DownSampling:
                    bf.push(...int16ToBytes(2));
                    bf.push(type);
                    bf.push(value ? 1 : 0);
                    break;
                case SettingType.OfflineData:
                    bf.push(...int16ToBytes(2));
                    bf.push(type);
                    // offline store mode (0x00: off, 0x01: save offline, 0x0A: both of realtime and offline)
                    bf.push(value ? 1 : 0);
                    break;
                case SettingType.Sensitivity:
                    bf.push(...int16ToBytes(2));
                    bf.push(type);
                    bf.push(value);
                    break;
                case SettingType.UsbMode:
                    bf.push(...int16ToBytes(2));
                    bf.push(type);
                    bf.push(value);
                    break;
                case SettingType.BtLocalName:
                    bf.push(...int16ToBytes(18));
                    bf.push(type);
                    tmp = toUTF8Array(value, 16);
                    bf.push(...tmp);
                    break;
                case SettingType.FscSensitivity:
                    bf.push(...int16ToBytes(2));
                    bf.push(type);
                    bf.push(value);
                    break;
                case SettingType.DataTransmissionType:
                    bf.push(...int16ToBytes(2));
                    bf.push(type);
                    bf.push(value);
                    break;
                case SettingType.BeepAndLight:
                    bf.push(...int16ToBytes(2));
                    bf.push(type);
                    bf.push(0);
                    break;
            }
            bf.push(PEN_PACKET_END);
            this.writeArray(bf);
        };
        /* #region  Offline Data */
        this.reqOnlineData_11 = () => {
            const bf = [
                PEN_PACKET_START,
                Cmd.ONLINE_DATA_REQUEST,
                0x02, 0x00, 0xff, 0xff,
                PEN_PACKET_END
            ];
            this.writeArray(bf);
        };
        /**
         * request the list of Offline data by section, owner, note (or all)
         * @param section
         * @param owner
         * @param book
         */
        this.reqOfflineDataListTask = {};
        this.reqOfflineDataList = (section = undefined, owner = undefined, book = undefined) => {
            if (section === undefined)
                section = -1;
            if (owner === undefined)
                owner = -1;
            const promise = new Promise((resolve, reject) => {
                this.reqOfflineDataListTask.resolve = resolve;
                this.reqOfflineDataListTask.reject = reject;
            });
            this.reqOfflineDataListTask.promise = promise;
            if (book === undefined) {
                this.reqOfflineDataList_21(section, owner);
            }
            else {
                this.reqOfflineDataList_22(section, owner, book);
            }
            return promise;
        };
        /**
         * request the list of Offline data by section, owner (or all)
         * @param section
         * @param owner
         */
        this.reqOfflineDataList_21 = (section = -1, owner = -1) => {
            const bf = [
                PEN_PACKET_START,
                Cmd.OFFLINE_NOTE_LIST_REQUEST,
                0x04, 0x00
            ];
            bf.push(...getSectionOwnerBytes(section, owner));
            bf.push(PEN_PACKET_END);
            this.writeArray(bf);
        };
        /**
         * request the list of Offline data by each note
         * @param section
         * @param owner
         * @param book
         */
        this.reqOfflineDataList_22 = (section, owner, book) => {
            const bf = [
                PEN_PACKET_START,
                Cmd.OFFLINE_PAGE_LIST_REQUEST,
                0x08, 0x00
            ];
            bf.push(...getSectionOwnerBytes(section, owner));
            bf.push(...int32ToBytes(book));
            bf.push(PEN_PACKET_END);
            this.writeArray(bf);
        };
        this.onReceiveOfflineDataList = (infos) => {
            this.setTimeStamp((new Date()).getTime());
            const e = makePenEvent(this.deviceInfo.deviceType, PenCommEventEnum.ON_OFFLINE_DATA_LIST_DELIVERED, {
                timeStamp: this.currentTime,
                offlineDataList: infos,
            });
            this.reqOfflineDataListTask.resolve(infos);
            this.penHandler.onOfflineDataListDelivered(e);
        };
        /**
         * request the list of Offline data by pages
         * @param s
         * @param o
         * @param b
         * @param deleteOnFinished
         * @param pgs
         */
        this.reqOfflineDataTask = {};
        /* #region  Receiving the offline data main */
        this.mReceivedOfflineStroke = 0;
        this.mTotalOfflineStroke = -1;
        this.mTotalOfflineDataSize = -1;
        this.offlineDataPacketRetryCount = 0;
        // public offlineFilterForPaper: FilterForPaper = null;
        this.reqOfflineData = (s, o, b, pgs = null, deleteOnFinished = true) => {
            console.log(`offline data downloading: ${s}.${o}.${b}.${pgs === null || pgs === void 0 ? void 0 : pgs.length}`);
            return this.reqOfflineData_23(s, o, b, pgs, deleteOnFinished);
        };
        this.reqOfflineData_23 = (section, owner, note, pages = null, deleteOnFinished = true) => {
            this.offlineStrokes = [];
            const promise = new Promise((resolve, reject) => {
                console.log("promise start");
                this.reqOfflineDataTask.resolve = resolve;
                this.reqOfflineDataTask.reject = reject;
            });
            this.reqOfflineDataTask.promise = promise;
            // request 본체
            let length = 14;
            length += (pages == null ? 0 : pages.length * 4);
            const bf = [];
            bf.push(PEN_PACKET_START);
            bf.push(Cmd.OFFLINE_DATA_REQUEST);
            bf.push(...int16ToBytes(length));
            bf.push(deleteOnFinished ? 1 : 2);
            bf.push(1); // compress:1, uncompress:0
            bf.push(...getSectionOwnerBytes(section, owner));
            bf.push(...int32ToBytes(note));
            bf.push(...int32ToBytes(pages == null ? 0 : pages.length));
            if (pages != null) {
                pages.forEach(page => {
                    bf.push(...int32ToBytes(page));
                });
            }
            bf.push(PEN_PACKET_END);
            // this.writeWithRetry(new Uint8Array(bf));
            sleep(10).then(() => {
                this.write(new Uint8Array(bf)).then((ret) => {
                    var _a;
                    if (ret) {
                        console.log("write succeeded");
                    }
                    else {
                        (_a = this.reqOfflineDataTask) === null || _a === void 0 ? void 0 : _a.reject(new Error("GATT retry count failed"));
                    }
                }).catch((reason) => {
                    console.log("ReqOfflineData error");
                });
            });
            return promise;
        };
        this.onStartOfflineDownload = () => {
            this.setTimeStamp((new Date()).getTime());
            const e = makePenEvent(this.deviceInfo.deviceType, PenCommEventEnum.ONSTARTOFFLINEDOWNLOAD, {
                timeStamp: this.currentTime,
            });
            this.penHandler.onStartOfflineDownload(e);
        };
        this.processOfflinePacketReceived_24 = (packet) => __awaiter(this, void 0, void 0, function* () {
            const assembled = yield processOfflinePacketReceived_main(this, packet);
            const { success, strokes, packetId, packetLocation } = assembled;
            switch (success) {
                case OfflineDataResultType.UNCOMPRESS_ERROR:
                case OfflineDataResultType.PACKET_SIZE_ERROR:
                    {
                        if (this.offlineDataPacketRetryCount < 3) {
                            this.sendOfflinePacketResponse_a4(packetId, false);
                            this.offlineDataPacketRetryCount++;
                        }
                        else {
                            this.offlineDataPacketRetryCount = 0;
                            // pencomm.onFinishedOfflineDownload(false);
                            this.onFinishedOfflineDownload(packetLocation === 2);
                        }
                    }
                    break;
                case OfflineDataResultType.DOT_DATA_CHECKSUM_ERROR:
                    {
                        this.offlineDataPacketRetryCount = 0;
                        this.onFinishedOfflineDownload(packetLocation === 2);
                    }
                    break;
                case OfflineDataResultType.SUCCESS:
                    {
                        this.offlineStrokes.push(...strokes);
                        this.sendOfflinePacketResponse_a4(packetId);
                        this.offlineDataPacketRetryCount = 0;
                        this.setTimeStamp((new Date()).getTime());
                        const event = makePenEvent(this.deviceInfo.deviceType, PenCommEventEnum.ON_OFFLINE_DATA_PART_DELIVERED, {
                            timeStamp: this.currentTime,
                            offlineData: {
                                totalStrokeCount: this.mTotalOfflineStroke,
                                receivedStrokeCount: this.mReceivedOfflineStroke,
                                strokes: strokes
                            }
                        });
                        this.penHandler.onOfflineDataDelivered(event);
                    }
                    break;
            }
            if (packetLocation == 2) {
                this.onFinishedOfflineDownload(true);
            }
        });
        this.sendOfflinePacketResponse_a4 = (/* short */ index, isSuccess = true) => {
            const bf = [];
            bf.push(PEN_PACKET_START);
            bf.push(Cmd.OFFLINE_PACKET_RESPONSE);
            bf.push(isSuccess ? 0 : 1);
            bf.push(...int16ToBytes(3));
            bf.push(...int16ToBytes(index));
            bf.push(1);
            bf.push(PEN_PACKET_END);
            this.writeArray(bf);
        };
        this.onFinishedOfflineDownload = (success) => {
            var _a;
            this.setTimeStamp((new Date()).getTime());
            const e = makePenEvent(this.deviceInfo.deviceType, PenCommEventEnum.ONFINISHEDOFFLINEDOWNLOAD, {
                timeStamp: this.currentTime,
                success,
                offlineData: {
                    totalStrokeCount: this.mTotalOfflineStroke,
                    receivedStrokeCount: this.mReceivedOfflineStroke,
                    strokes: this.offlineStrokes,
                }
            });
            this.penHandler.onFinishedOfflineDownload(e);
            if (success) {
                (_a = this.reqOfflineDataTask) === null || _a === void 0 ? void 0 : _a.resolve({
                    mTotalOfflineStroke: this.mTotalOfflineStroke,
                    mTotalOfflineDataSize: this.mTotalOfflineDataSize,
                    strokes: this.offlineStrokes,
                });
            }
        };
        /* #endregion */
        this.reqRemoveOfflineData_25 = (section, owner, notes) => {
            const bf = [];
            bf.push(PEN_PACKET_START);
            bf.push(Cmd.OFFLINE_DATA_DELETE_REQUEST);
            const length = (5 + (notes.length * 4));
            bf.push(...int16ToBytes(length));
            bf.push(...getSectionOwnerBytes(section, owner));
            bf.push(notes.length);
            notes.forEach(note => {
                bf.push(...int32ToBytes(note));
            });
            bf.push(PEN_PACKET_END);
            this.writeArray(bf);
        };
        /* #region  Pen profile */
        this.reqCreateProfile = (profileName, password) => {
            const bf = [];
            bf.push(PEN_PACKET_START);
            bf.push(Cmd.PEN_PROFILE_REQUEST); // command
            bf.push(...int16ToBytes(PenProfile.LIMIT_BYTE_LENGTH_PROFILE_NAME + 1 + PenProfile.LIMIT_BYTE_LENGTH_PASSWORD + 2 + 2)); // length
            bf.push(...Array.from(profileName), PenProfile.LIMIT_BYTE_LENGTH_PROFILE_NAME); // profile file name
            bf.push(PenProfile.PROFILE_CREATE); // type
            bf.push(...Array.from(password), PenProfile.LIMIT_BYTE_LENGTH_PASSWORD); // password
            bf.push(...int16ToBytes(32)); // section 크기 -> 32인 이유? 우선 android따라감. 확인필요
            bf.push(...int16ToBytes(32)); // sector 개수(2^N 현재는 고정 2^8)
            bf.push(PEN_PACKET_END);
            this.writeArray(bf);
        };
        this.reqDeleteProfile = (profileName, password) => {
            const bf = [];
            bf.push(PEN_PACKET_START);
            bf.push(Cmd.PEN_PROFILE_REQUEST); // command
            bf.push(...int16ToBytes((PenProfile.LIMIT_BYTE_LENGTH_PROFILE_NAME + 1 + PenProfile.LIMIT_BYTE_LENGTH_PASSWORD))); // length
            bf.push(...Array.from(profileName), PenProfile.LIMIT_BYTE_LENGTH_PROFILE_NAME); // profile file name
            bf.push(PenProfile.PROFILE_DELETE); // type
            bf.push(...Array.from(password), PenProfile.LIMIT_BYTE_LENGTH_PASSWORD); // password
            bf.push(PEN_PACKET_END);
            this.writeArray(bf);
        };
        this.reqProfileInfo = (profileName) => {
            const bf = [];
            bf.push(PEN_PACKET_START);
            bf.push(Cmd.PEN_PROFILE_REQUEST); // command
            bf.push(...int16ToBytes((PenProfile.LIMIT_BYTE_LENGTH_PROFILE_NAME + 1))); // length
            bf.push(...Array.from(profileName), PenProfile.LIMIT_BYTE_LENGTH_PROFILE_NAME); // profile file name
            bf.push(PenProfile.PROFILE_INFO); // type
            bf.push(PEN_PACKET_END);
            this.writeArray(bf);
        };
        this.reqWriteProfileValue = (profileName, password, keys, data) => {
            let dataLength = 0;
            const dataCount = data.length;
            for (let i = 0; i < dataCount; ++i) {
                dataLength += PenProfile.LIMIT_BYTE_LENGTH_KEY; // key
                dataLength += 2; // data length
                dataLength += data[i].length; // data
            }
            const bf = [];
            bf.push(PEN_PACKET_START);
            bf.push(Cmd.PEN_PROFILE_REQUEST); // command
            bf.push(...int16ToBytes((PenProfile.LIMIT_BYTE_LENGTH_PROFILE_NAME + 1 + PenProfile.LIMIT_BYTE_LENGTH_PASSWORD + 1 + dataLength))); // length
            bf.push(...Array.from(profileName), PenProfile.LIMIT_BYTE_LENGTH_PROFILE_NAME); // profile file name
            bf.push(PenProfile.PROFILE_WRITE_VALUE); // type
            bf.push(...Array.from(password), PenProfile.LIMIT_BYTE_LENGTH_PASSWORD); // password
            bf.push(dataCount); // count
            for (let i = 0; i < dataCount; ++i) {
                bf.push(...Array.from(keys[i]), PenProfile.LIMIT_BYTE_LENGTH_KEY);
                bf.push(...int16ToBytes(data[i].length));
                bf.push(...Array.from(data[i]));
            }
            bf.push(PEN_PACKET_END);
            this.writeArray(bf);
        };
        this.reqReadProfileValue = (profileName, keys) => {
            const bf = [];
            bf.push(PEN_PACKET_START);
            bf.push(Cmd.PEN_PROFILE_REQUEST); // command
            bf.push(...int16ToBytes((PenProfile.LIMIT_BYTE_LENGTH_PROFILE_NAME + 1 + 1 + PenProfile.LIMIT_BYTE_LENGTH_KEY * keys.length))); // Length
            bf.push(...Array.from(profileName), PenProfile.LIMIT_BYTE_LENGTH_PROFILE_NAME); // profile file name
            bf.push(PenProfile.PROFILE_READ_VALUE); // Type
            bf.push(keys.length); // Key Count
            for (let i = 0; i < keys.length; ++i) {
                bf.push(...Array.from(keys[i]), PenProfile.LIMIT_BYTE_LENGTH_KEY);
            }
            bf.push(PEN_PACKET_END);
            this.writeArray(bf);
        };
        this.reqDeleteProfileValue = (profileName, password, keys) => {
            const bf = [];
            bf.push(PEN_PACKET_START);
            bf.push(Cmd.PEN_PROFILE_REQUEST); // command
            bf.push(...int16ToBytes((PenProfile.LIMIT_BYTE_LENGTH_PROFILE_NAME + 1 + PenProfile.LIMIT_BYTE_LENGTH_PASSWORD + 1 + PenProfile.LIMIT_BYTE_LENGTH_KEY * keys.length))); // Length
            bf.push(...Array.from(profileName), PenProfile.LIMIT_BYTE_LENGTH_PROFILE_NAME); // profile file name
            bf.push(PenProfile.PROFILE_DELETE_VALUE); // Type
            bf.push(...Array.from(password), PenProfile.LIMIT_BYTE_LENGTH_PASSWORD); // password
            bf.push(keys.length); // key count
            for (let i = 0; i < keys.length; ++i) {
                bf.push(...Array.from(keys[i]), PenProfile.LIMIT_BYTE_LENGTH_KEY);
            }
            bf.push(PEN_PACKET_END);
            this.writeArray(bf);
        };
        /* #endregion */
        // PROCESS A UNIT PACKET GOTTEN FROm PEN
        //
        // unit packet should be start with 0xC0 and end by 0xC1
        this.processUnitPacket = (unit_packet) => {
            // console.log(`received packet length = ${unit_packet.length}`);
            // const this = this;
            const cmd = unit_packet[1];
            // console.log(`  processUnitPacket: 0x${cmd.toString(16)}  size(${unit_packet.length})`);
            switch (cmd) {
                case Cmd.VERSION_RESPONSE: // 0x81:
                    this.process_81_device_first_info(unit_packet);
                    break;
                // /* #region request pen data */
                // case Cmd.ONLINE_PEN_DATA_REQUEST: // 0x12
                //   // TODO: 여기 할 것 채워 넣기, V200 에서는 없다
                //   break;
                // /* #endregion */
                /* #region Event */
                case Cmd.SHUTDOWN_EVENT: // 0x62
                    this.process_62_shutdown_event();
                    break;
                case Cmd.LOW_BATTERY_EVENT: // 0x61
                    this.process_61_low_battery_event();
                    break;
                case Cmd.ONLINE_PEN_UPDOWN_EVENT: // 0x63:
                    this.process_63_penupdown_v100(unit_packet);
                    break;
                case Cmd.ONLINE_PAPER_INFO_EVENT: // 0x64:
                    this.process_64_pageinfo_v100(unit_packet);
                    break;
                case Cmd.ONLINE_PEN_DOT_EVENT_V100: // 0x65:
                    this.process_65_penmove_v100(unit_packet);
                    break;
                case Cmd.ONLINE_PEN_DOT_EVENT_V200: // 0x66:
                    this.process_66_penmove_simple_v200(unit_packet);
                    break;
                case Cmd.ONLINE_PEN_ERROR_EVENT: // 0x68:
                    this.process_68_ndac_error_v100(unit_packet);
                    break;
                case Cmd.ONLINE_NEW_PEN_DOWN_EVENT: // 0x69:
                    this.process_69_pendown_v212(unit_packet);
                    break;
                case Cmd.ONLINE_NEW_PEN_UP_EVENT: // 0x6a:
                    this.process_6a_penup_v212(unit_packet);
                    break;
                case Cmd.ONLINE_NEW_PAPER_INFO_EVENT: // 0x6b:
                    this.process_6b_pageinfo_v212(unit_packet);
                    break;
                case Cmd.ONLINE_NEW_PEN_DOT_EVENT: // 0x6c:
                    this.process_6c_penmove_v212(unit_packet);
                    break;
                case Cmd.ONLINE_PEN_HOVER_MOVE_EVENT: // 0x6f:
                    this.process_6f_hovermove_v218(unit_packet);
                    break;
                case Cmd.ONLINE_NEW_PEN_ERROR_EVENT: // 0x6d:
                    this.process_6d_ndacerror_v212(unit_packet);
                    break;
                /* #endregion */
                /* #region  Setting response */
                case Cmd.SETTING_INFO_RESPONSE: // 0x84:
                    this.process_84_device_status(unit_packet);
                    break;
                case Cmd.SETTING_CHANGE_RESPONSE: // 0x85:
                    this.process_85_config_response(unit_packet);
                    break;
                case Cmd.ONLINE_DATA_RESPONSE: // 0x91:
                    this.process_91_realtime_mode_response(unit_packet);
                    break;
                /* #endregion */
                /* #region  Password response */
                case Cmd.PASSWORD_RESPONSE: // 0x82:
                    this.process_82_pw_result(unit_packet);
                    break;
                case Cmd.PASSWORD_CHANGE_RESPONSE: // 0x83
                    {
                        const packet = new Packet(unit_packet);
                        const cntRetry = packet.GetByteToInt();
                        const cntMax = packet.GetByteToInt();
                        if (packet.result_code == 0x00) {
                            this.reCheckPassword = true;
                            this.reqPassword_02(this.newPassword);
                        }
                        else {
                            this.newPassword = "";
                            this.onPenPasswordSetupResponse(false);
                        }
                    }
                    break;
                /* #endregion */
                /* #region  Offline response */
                case Cmd.OFFLINE_NOTE_LIST_RESPONSE: // 0xa1
                    {
                        const packet = new Packet(unit_packet);
                        const length = packet.GetShort();
                        const result = [];
                        for (let i = 0; i < length; i++) {
                            const rb = packet.GetBytes(4);
                            const section = (rb[3] & 0xFF);
                            const owner = ByteConverter.ByteToInt([rb[0], rb[1], rb[2], 0x00]);
                            const note = packet.GetInt();
                            result.push(new OfflineDataInfo(section, owner, note));
                        }
                        this.onReceiveOfflineDataList(result);
                    }
                    break;
                case Cmd.OFFLINE_PAGE_LIST_RESPONSE: // 0xa2
                    {
                        const packet = new Packet(unit_packet);
                        const rb = packet.GetBytes(4);
                        const section = (rb[3] & 0xFF);
                        const owner = ByteConverter.ByteToInt([rb[0], rb[1], rb[2], 0x00]);
                        const note = packet.GetInt();
                        const length = packet.GetShort();
                        const pages = Array.from({ length }, (_, i) => 0);
                        for (let i = 0; i < length; i++) {
                            pages[i] = packet.GetInt();
                        }
                        const info = new OfflineDataInfo(section, owner, note, pages);
                        this.onReceiveOfflineDataList([info]);
                    }
                    break;
                case Cmd.OFFLINE_DATA_RESPONSE: // 0xa3
                    {
                        const packet = new Packet(unit_packet);
                        this.mTotalOfflineStroke = packet.GetInt();
                        this.mReceivedOfflineStroke = 0;
                        this.mTotalOfflineDataSize = packet.GetInt();
                        if (this.mTotalOfflineStroke === 0) {
                            this.onFinishedOfflineDownload(true);
                        }
                        else {
                            this.onStartOfflineDownload();
                        }
                    }
                    break;
                case Cmd.OFFLINE_PACKET_REQUEST: // 0x24
                    {
                        const packet = new Packet(unit_packet);
                        this.processOfflinePacketReceived_24(packet);
                    }
                    break;
                /* #endregion */
                default:
                    break;
            }
        };
        this.onPhysicallyConnected = () => {
            if (this.isNowConnecting) {
                this.setProtocolTimeout("    BT protocol #1 -> send the first packet");
                this.reqVersion_01();
            }
            else {
                this.disconnect();
            }
        };
        /**
         * process response packet from cmd 0x01
         * 디바이스이름, 펌웨어버전, 회사 이름, 펜 종류, 필압센서 종류 등의 reposnse
         *
         * @param buf
         */
        this.process_81_device_first_info = (buf) => {
            /**
             *  0:  1 - header
             *  1:  1 - cmd (0x81)
             *  2:  1 - error code
             *  3:  2 - length
             *
             *  5: 16 - device name
             * 21: 16 - firmware version
             * 37:  8 - protocol version
             * 45: 16 - company name
             * 61:  2 - device type (0,:pen, 2:eraser, 3:player)
             * 63:  6 - MAC address
             * 69:  1 - FS (0:FSR, 1:FSC, 2:up/down, 3:FSIR)
             * 70:  4 - device color type id
             */
            this.clearProtocolTimeout();
            const Errcode = buf[2];
            const modelNameArry = []; //NWP-F30 ~ NWP-F121HL
            for (let i = 5; i < 16; i++) {
                if (buf[i] > 0)
                    modelNameArry.push(buf[i] & 0xff);
            }
            const modelNameString = String.fromCharCode.apply(null, modelNameArry);
            const protocolVer = (buf[37] - 0x30) * 100 + (buf[39] - 0x30) * 10 + (buf[40] - 0x30);
            console.log(`    BT protocol #1 <- connection result: ${Errcode} ${protocolVer}`);
            this.deviceInfo.modelName = modelNameString;
            this.deviceInfo.protocolVer = protocolVer;
            // this.deviceInfo.mac = intFromBytes(buf, 63, 6).toString(16).toUpperCase();
            this.deviceInfo.mac = decimalToHex(buf[63], 2) + ":" +
                decimalToHex(buf[64], 2) + ":" +
                decimalToHex(buf[65], 2) + ":" +
                decimalToHex(buf[66], 2) + ":" +
                decimalToHex(buf[67], 2) + ":" +
                decimalToHex(buf[68], 2);
            //
            const typeNumber = intFromBytes(buf, 61, 2);
            function getPenType_on_81(number) {
                let result = DeviceTypeEnum.PEN;
                switch (number) {
                    case 0:
                    case 1:
                        result = DeviceTypeEnum.PEN;
                        break;
                    case 2:
                        result = DeviceTypeEnum.ERASER;
                        break;
                    case 3:
                        result = DeviceTypeEnum.FSIR;
                        break;
                    default:
                        result = DeviceTypeEnum.PEN;
                        console.error(`device type mismatch (not 0, 1, neither 2), Pen type from pen is ${typeNumber}`);
                        break;
                }
                return result;
            }
            this.deviceInfo.deviceType = getPenType_on_81(typeNumber);
            // t.deviceType = getPenType(typeNumber);
            if (this.isNowConnecting) {
                this.setProtocolTimeout(`    BT protocol #2 -> request pen status`);
                this.reqConfig_04();
            }
            else {
                this.disconnect();
            }
        };
        /**
         * 펜 설정 확인의 response (CMD 0x04의 결과)
         * @param buf
         */
        this.process_84_device_status = (buf) => {
            /**
             *  0:  1 - header
             *
             *  1:  1 - cmd (0x82)
             *  2:  1 - error code
             *  3:  2 - length
             *
             *  5:  1 - locked or not (0:no password, 1:password locked)
             *  6:  1 - retry limit
             *  7:  1 - current retry count
             *  8:  8 - penTime(uint64), millisecond tick from 1970/01/01
             * 16:  2 - auto power off time (unit: minutes)
             * 18:  2 - maximum force (< 0x3ff)
             * 20:  1 - storage capacity % (100%)
             * 21:  1 - pencap auto on/off (0:false, 1:true)
             * 22:  1 - auto power on  (0:false, 1:true)
             * 23:  1 - beep on (0:off, 1:on)
             * 24:  1 - hover on (0:off, 1:on)
             * 25:  1 - battery status (MSB:in charging, LSB 7bits: 100%)
             * 26:  1 - offline stroke store or not (0:off, 1:on)
             * 27:  1 - pressure sensor step (0~4, 0 is most sensitive)
             * 28:  1 - usb mode (0:disk, 1:bulk)
             * 29:  1 - down sampling (0:off, 1:on), isPathSimplifyOn
             * 30: 16 - BT local name
             * 46:  1 - data transfer mode (0:event, 1:requset/response(from 2.10 deleted))
             * 47:  1 - ndac error code offline store or not (0:false, 1:true)
             * 48: 21 - reserverd
             */
            this.clearProtocolTimeout();
            // response
            const isPwLocked = buf[5] !== 0;
            const retryLimit = buf[6];
            const retryCount = buf[7];
            const penTime = intFromBytes(buf, 8, 8);
            const autoPowerOffTimeMinutes = intFromBytes(buf, 16, 2);
            const maxPressureValue = intFromBytes(buf, 18, 2);
            this.PenMaxForce = maxPressureValue;
            const storageUsagePercent = buf[20];
            const autoPenCapOnOff = buf[21] !== 0;
            const autoPowerOn = buf[22] !== 0;
            const beepOn = buf[23] !== 0;
            const hoverModeOn = buf[24] !== 0;
            const batteryLevelPercent = buf[25];
            const isSupportOfflineStore = buf[26] !== 0;
            const pressureSensitivity = buf[27]; // 0~4, 0: the most senstive
            const usbMode = buf[28] === 0 ? PenUsbMode.DISK : PenUsbMode.BULK;
            const isPathSimplifyOn = buf[29] !== 0;
            const btLocalName = strFromBytes(buf, 30, 16);
            const isStoreErrorLogOn = buf[47] !== 0;
            console.log(`    BT protocol #2 <- IsLock? ${isPwLocked} memory:${storageUsagePercent}%, battery:${batteryLevelPercent}%`);
            const status = {
                isPwLocked, retryLimit, currentRetryCount: retryCount, penTime, autoPowerOffTimeMinutes, maxPressureValue, storageUsagePercent,
                autoPenCapOnOff, autoPowerOn, beepOn, hoverModeOn, batteryLevelPercent, isSupportOfflineStore, pressureSensitivity,
                usbMode, isPathSimplifyOn, btLocalName, isStoreErrorLogOn,
            };
            this.initialStatus = status;
            const e = makePenEvent(this.deviceInfo.deviceType, PenCommEventEnum.PASSWORD_REQUIRED, { timeStamp: this.currentTime, status });
            this.penHandler.onPenStatusResponse(e);
            let bufferArray;
            if (isPwLocked) {
                const e = makePenEvent(this.deviceInfo.deviceType, PenCommEventEnum.PASSWORD_REQUIRED, {
                    timeStamp: this.currentTime,
                    passcodeStatus: {
                        retryLimit,
                        retryCount,
                    }
                });
                this.penHandler.onPasscodeRequired(e);
                // // input passcode
                // console.log("    BT protocol #3 -> input passcode ");
                // bufferArray = new Uint8Array([0xc0, 0x02, 0x10, 0x00, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0xc1]);
                // bufferArray[4] = passcode.charCodeAt(0);
                // bufferArray[5] = passcode.charCodeAt(1);
                // bufferArray[6] = passcode.charCodeAt(2);
                // bufferArray[7] = passcode.charCodeAt(3);
                // console.log("    passcode1 :" + bufferArray[4]);
                // console.log("    passcode2 :" + bufferArray[5]);
                // console.log("    passcode3 :" + bufferArray[6]);
                // console.log("    passcode4 :" + bufferArray[7]);
                // this.write(bufferArray);
                // // g_btWriteSocket.writeValue(bufferArray);
            } // unlocked
            else {
                // time setting and go next
                if (this.isNowConnecting) {
                    this.setOfflineStoreModeAtConnection();
                }
                // bufferArray = new Uint8Array([
                //   PEN_PACKET_START,
                //   Cmd.ONLINE_DATA_REQUEST, // 0x11,
                //   0x02, 0x00, 0xff, 0xff,
                //   PEN_PACKET_END
                // ]);
                // // g_btWriteSocket.writeValue(bufferArray);
                // this.write(bufferArray);
            }
        };
        /**
         * 패스워드 송신 후의 reponse
         * @param buf
         */
        this.process_82_pw_result = (buf) => {
            /**
             *  0:  1 - header
             *  1:  1 - cmd (0x81)
             *  2:  1 - error code
             *  3:  2 - length
             *  5:  1 - password response (0:pw needed, 1:success(or not needed), 2:pen was reset, 3:system error)
             *  6:  1 - retry limit
             *  7:  1 - current retry count
             */
            // response check passcode
            const pwCheckResult = buf[5];
            /** @type {number} */
            const retryCount = buf[6];
            const maxCount = buf[7];
            if (pwCheckResult === 1) {
                if (this.reCheckPassword) {
                    this.onPenPasswordSetupResponse(true);
                    this.reCheckPassword = false;
                }
                console.log("    BT protocol #3 <- passcode none ==> OK ");
                // passcode OK
                // 연결 핸드쉐이킹 도중이라면
                if (this.isNowConnecting) {
                    this.setOfflineStoreModeAtConnection();
                }
            }
            else {
                console.log(`    BT protocol #3 <- passcode NG ${retryCount}/${maxCount}`);
                // retry input passcode
                //alert("wrong passcode");
                const e = makePenEvent(this.deviceInfo.deviceType, PenCommEventEnum.PASSWORD_REQUIRED, {
                    timeStamp: this.currentTime,
                    // retryCount,
                    passcodeStatus: {
                        retryLimit: this.initialStatus.retryLimit,
                        retryCount,
                    }
                });
                this.penHandler.onPasscodeRequired(e);
            }
        };
        /**
         * Set transfer mode, by 5th byte
         * offline store mode (0x00: off, 0x01: save offline, 0x0A: both of realtime and offline)
         * @param mode
         */
        this.setTransferMode = (mode) => {
            this.reqChangeSetting_05(SettingType.OfflineData, mode);
            // /**
            //  *  0:  1 - header
            //  *  1:  1 - cmd (0x05)
            //  *  2:  2 - length (0x02)
            //  *  4:  1 - attribute type (0x07)
            //  *  5:  1 - offline store mode (0x00: off, 0x01: save offline, 0x0A: both of realtime and offline)
            //  */
            // if (val !== 0 && val !== 1 && val !== 100) return;
            // const bufferArray = new Uint8Array([
            //   PEN_PACKET_START,
            //   Cmd.SETTING_CHANGE_REQUEST, // 0x05,
            //   0x02, 0x00, 0x07, val,
            //   PEN_PACKET_END
            // ]);
            // // g_btWriteSocket.writeValue(bufferArray);
            // this.write(bufferArray);
        };
        /**
         * hover on/off (0:hover mode off, 1:hover mode on)
         * @param val
         */
        this.setHoverMode = (mode) => {
            mode &= 0x01;
            this.reqChangeSetting_05(SettingType.Hover, mode);
        };
        this.setOfflineStoreModeAtConnection = () => {
            if (this.isNowConnecting) {
                this.setProtocolTimeout("    BT protocol #4 -> setup offline store mode to 0x01");
                // offline store mode (0x00: off, 0x01: save offline data, 0x0A: both of realtime and offline)
                this.reqChangeSetting_05(SettingType.OfflineData, 1);
            }
            else {
                this.disconnect();
            }
        };
        this.setTimeAtConnectionAndReqOnlineData = () => {
            if (this.isNowConnecting) {
                this.setProtocolTimeout("    BT protocol #5 -> setup realtime clock");
                // refer to this.process_85_config_response(),
                // if (this._shouldProcessReqOnlineData), req online data next
                this._shouldProcessReqOnlineData = true;
                this.reqChangeSetting_05(SettingType.Timestamp, (new Date()).getTime());
            }
            else {
                this.disconnect();
            }
        };
        this.on_85_config_response_duringConnection = (buf) => {
            this.clearProtocolTimeout();
            const type = buf[5];
            if (type === SettingType.OfflineData) {
                console.log("    BT protocol #4 <- offline store mode ==> OK ");
                this.setTimeAtConnectionAndReqOnlineData();
            }
            else if (type === SettingType.Timestamp) {
                console.log("    BT protocol #5 <- setup realtime clock ==> OK ");
                if (this._shouldProcessReqOnlineData) {
                    this._shouldProcessReqOnlineData = false;
                    // request online
                    if (this._requestOnlineDataOnConencted) {
                        this.requestOnlineStrokeOnConnection();
                    }
                    else {
                        // 여기서 connect()의 promise를 resolve
                        this.clearProtocolTimeout();
                        this._connectionTask.resolve(true);
                        this._connectionTask = {};
                    }
                }
            }
            else if (type === SettingType.Hover) {
                this.clearProtocolTimeout();
                this._connectionTask.resolve(true);
                this._connectionTask = {};
            }
        };
        /**
         * pen up/down, protocol version 1.00
         * @param buf
         */
        this.process_63_penupdown_v100 = (buf) => {
            /**
             *  0:  1 - header
             *
             *  1:  1 - cmd (0x63)
             *  2:  2 - length
             *
             *  4:  1 - up/down (0:down, 1:up)
             *  5:  8 - timestamp
             * 13:  1 - pen tip type (0:normal, 1:eraser)
             * 14:  4 - color (argb)
            */
            const isPenDown = buf[4] === 0;
            const penTipMode = buf[13];
            const mac = this.getMac();
            const timeStamp = intFromBytes(buf, 5, 8); // ARGB
            this.setTimeStamp(timeStamp);
            if (isPenDown) {
                console.log("------------ Pen down --------------");
                this.isPenDown = true;
                const event = makePenEvent(this.deviceInfo.deviceType, PenCommEventEnum.PEN_DOWN, { penTipMode, timeStamp, mac: mac });
                this.penHandler.onPenDown(event);
                return;
            }
            else {
                console.log("^^^^^^^^^^^^^^ pen up ^^^^^^^^^^^^^");
                this.isPenDown = false;
                const event = makePenEvent(this.deviceInfo.deviceType, PenCommEventEnum.PEN_UP, { penTipMode, timeStamp });
                this.penHandler.onPenUp(event);
                return;
            }
        };
        /**
         * page information,
         * pen down 직후, pen up 직후에 전송되어 옴
         * @param buf
         */
        this.process_64_pageinfo_v100 = (buf) => {
            /**
             *  0:  1 - header
             *
             *  1:  1 - cmd (0x64)
             *  2:  2 - length
             *
             *  4:  3 - owner
             *  7:  1 - section
             *  8:  4 - note id
             * 12:  4 - page id
            */
            const section = buf[7];
            const owner = intFromBytes(buf, 4, 3);
            const book = intFromBytes(buf, 8, 4);
            const page = intFromBytes(buf, 12, 4);
            //console.log('owner:' + ownerId + ', book:' + bookId + ', page:' + pageId);
            let eventMode = PenCommEventEnum.PAGE_INFO;
            if (!this.isPenDown) {
                eventMode = PenCommEventEnum.PAGE_INFO_HOVER;
            }
            const e = makePenEvent(this.deviceInfo.deviceType, eventMode, { section, owner, book, page, timeStamp: this.currentTime });
            // console.log("    #1 INFO");
            const isHover = eventMode === PenCommEventEnum.PAGE_INFO_HOVER;
            // console.log( "0x64");
            this.penHandler.onPageInfo(e, isHover);
            return;
        };
        /**
         * Pen Move, protocol version 1.00
         * @param buf
         */
        this.process_65_penmove_v100 = (buf) => {
            /**
             *  0:  1 - header
             *
             *  1:  1 - cmd (0x65)
             *  2:  2 - length
             *  4:  1 - time diff
             *
             *  5:  2 - force
             *  7:  2 - x
             *  9:  2 - y
             * 11:  1 - float x
             * 12:  1 - float y
             * 13:  1 - x tilt
             * 14:  1 - y tilt
             * 15:  2 - twist (0~180, 360 degree => 180)
            */
            const timediff = buf[4];
            this.accTime(timediff);
            const force = intFromBytes(buf, 5, 2);
            const dotX = intFromBytes(buf, 7, 2);
            const dotY = intFromBytes(buf, 9, 2);
            const dotFx = intFromBytes(buf, 11, 1);
            const dotFy = intFromBytes(buf, 12, 1);
            const x = dotX + dotFx / 100;
            const y = dotY + dotFy / 100;
            const e = makePenEvent(this.deviceInfo.deviceType, PenCommEventEnum.PEN_MOVE, { force, x, y, timediff, timeStamp: this.currentTime });
            // e.force = force;
            // e.x = x;
            // e.y = y;
            // e.timediff = timediff;
            console.log(`    #1 MOVE ( ${x}, ${y} )`);
            this.penHandler.onPenMove(e);
            return;
        };
        /**
         * pen move, for slow connection, protocol version 2.00
         * @param buf
         */
        this.process_66_penmove_simple_v200 = (buf) => {
            /**
             *  0:  1 - header
             *
             *  1:  1 - cmd (0x66)
             *  2:  2 - length
             *  4:  1 - time diff
             *
             *  5:  2 - x
             *  7:  2 - y
             *  9:  1 - float x
             * 10:  1 - float y
            */
            const timediff = buf[4];
            this.accTime(timediff);
            const force = 100;
            const dotX = intFromBytes(buf, 5, 2);
            const dotY = intFromBytes(buf, 7, 2);
            const dotFx = intFromBytes(buf, 9, 1);
            const dotFy = intFromBytes(buf, 10, 1);
            const x = dotX + dotFx / 100;
            const y = dotY + dotFy / 100;
            const e = makePenEvent(this.deviceInfo.deviceType, PenCommEventEnum.PEN_MOVE, { force, x, y, timediff, timeStamp: this.currentTime });
            // e.force = force;
            // e.x = x;
            // e.y = y;
            // e.timediff = timediff;
            console.log(`    #2 MOVE ( ${x}, ${y} )`);
            this.penHandler.onPenMove(e);
            return;
        };
        /**
         * On NDAC Error, protocol v1.00
         * @param buf
         */
        this.process_68_ndac_error_v100 = (buf) => {
            /**
             *  0:  1 - header
             *
             *  1:  1 - cmd (0x68)
             *  2:  2 - length
             *  4:  1 - time diff
             *
             *  5:  2 - force
             *  7:  1 - image brightness
             *  8:  1 - exposure time
             *  9:  1 - NDAC process time
             * 10:  2 - label count
             * 12:  1 - ndac error code
            */
            // const this = this;
            const timediff = buf[4];
            this.accTime(timediff);
            const force = intFromBytes(buf, 5, 2);
            const brightness = buf[7];
            const exposureTime = buf[8];
            const ndacProcessTime = buf[9];
            const labelCount = intFromBytes(buf, 10, 2);
            const ndacErrorCode = buf[12];
            const ndacClassType = buf[14];
            const mac = this.getMac();
            const e = makePenEvent(this.deviceInfo.deviceType, PenCommEventEnum.ERROR, {
                timeStamp: this.currentTime,
                timediff,
                force,
                brightness,
                exposureTime,
                ndacProcessTime,
                labelCount,
                ndacErrorCode,
                ndacClassType,
                mac: mac
            });
            // this.isPenDown = true;
            console.log("    PEN DOWN");
            this.penHandler.onPenDown(e);
        };
        /**
         * pen down, v2.12
         * @param buf
         */
        this.process_69_pendown_v212 = (buf) => {
            /**
             *  0:  1 - header
             *
             *  1:  1 - cmd (0x69)
             *  2:  2 - length
             *  4:  1 - event count
             *
             *  5:  8 - timeStamp
             *  13:  1 - pen tip type (0:normal, 1:eraser)
             *  14:  4 - pen tip color (argb)
            */
            // console.log("    PEN DOWN");
            const timeStamp = intFromBytes(buf, 5, 8); // ARGB
            this.setTimeStamp(timeStamp);
            const penTipMode = buf[13];
            const color = intFromBytes(buf, 14, 4); // ARGB
            const mac = this.getMac();
            this.isPenDown = true;
            const e = makePenEvent(this.deviceInfo.deviceType, PenCommEventEnum.PEN_DOWN, { penTipMode, color, timeStamp, mac: mac });
            this.penHandler.onPenDown(e);
        };
        /**
         * pen up, v2.12
         * @param buf
         */
        this.process_6a_penup_v212 = (buf) => {
            /**
             *  0:  1 - header
             *
             *  1:  1 - cmd (0x6A)
             *  2:  2 - length
             *  4:  1 - event count
             *
             *  5:  8 - timestamp
             *
             * 13:  2 - dot count (down-up 사이에 BT로 전송한 dot code 개수)
             * 15:  2 - total image count (down-up 사이에 촬영된 이미지 개수)
             * 17:  2 - proc image count (처리한 이미지 개수)
             * 19:  2 - success image count (처리에 성공한 이미지 개수)
             * 21:  2 - valid image count (밝기 등으로 유효한 이미지 개수)
            */
            // console.log("    PEN UP");
            const timeStamp = intFromBytes(buf, 5, 8); // ARGB
            this.setTimeStamp(timeStamp);
            // const dotCount = intFromBytes(buf, 13, 2);
            const totalImageCount = intFromBytes(buf, 15, 2);
            // const procImageCount = intFromBytes(buf, 17, 2);
            const successImageCount = intFromBytes(buf, 19, 2);
            const validImageCount = intFromBytes(buf, 21, 2);
            // console.log(`totalImageCount: ${totalImageCount} `);
            // console.log(`procImageCount: ${procImageCount} `);
            // console.log(`successImageCount: ${successImageCount} `);
            // console.log(`validImageCount: ${validImageCount} `);
            const successRate_ndac = successImageCount / totalImageCount;
            const successRate_optical = validImageCount / totalImageCount;
            this.isPenDown = false;
            const e = makePenEvent(this.deviceInfo.deviceType, PenCommEventEnum.PEN_UP, { successRate_ndac, successRate_optical, timeStamp });
            this.penHandler.onPenUp(e);
        };
        /**
         * page info packet, v2.12
         * @param buf
         */
        this.process_6b_pageinfo_v212 = (buf) => {
            /**
             *  0:  1 - header
             *
             *  1:  1 - cmd (0x6B)
             *  2:  2 - length
             *  4:  1 - event count
             *
             *  5:  3 - owner
             *  8:  1 - section
             *  9:  4 - book
             * 13:  4 - page
            */
            const owner = intFromBytes(buf, 5, 3);
            const section = intFromBytes(buf, 8, 1);
            const book = intFromBytes(buf, 9, 4);
            const page = intFromBytes(buf, 13, 4);
            let eventMode = PenCommEventEnum.PAGE_INFO;
            if (!this.isPenDown) {
                eventMode = PenCommEventEnum.PAGE_INFO_HOVER;
            }
            const e = makePenEvent(this.deviceInfo.deviceType, eventMode, { section, owner, book, page, timeStamp: this.currentTime });
            const isHover = eventMode === PenCommEventEnum.PAGE_INFO_HOVER;
            // console.log("0x6b");
            // console.log(`    PEN INFO, page address: ${o}.${b}.${p} ${isHover ? "HOVER" : "PEN DOWN"} `);
            this.penHandler.onPageInfo(e, isHover);
        };
        /**
         * pen move, v2.12
         * @param buf
         */
        this.process_6c_penmove_v212 = (buf) => {
            /**
             *  0:  1 - header
             *
             *  1:  1 - cmd (0x6C)
             *  2:  2 - length
             *  4:  1 - event count
             *  5:  1 - delta time
             *
             *  6:  2 - force
             *  8:  2 - x
             * 10:  2 - y
             * 12:  1 - float x
             * 13:  1 - float y
             *
             * 14:  1 - x tilt
             * 15:  1 - y tilt
             * 16:  2 - twist
            */
            // pen down moving (or hover moving, in firmware <2.18 )
            const timediff = buf[5];
            this.accTime(timediff);
            const force = intFromBytes(buf, 6, 2);
            const dotX = intFromBytes(buf, 8, 2);
            const dotY = intFromBytes(buf, 10, 2);
            const dotFx = intFromBytes(buf, 12, 1);
            const dotFy = intFromBytes(buf, 13, 1);
            const x = dotX + dotFx / 100;
            const y = dotY + dotFy / 100;
            const e = makePenEvent(this.deviceInfo.deviceType, PenCommEventEnum.PEN_MOVE, { x, y, force, timediff, timeStamp: this.currentTime });
            this.penHandler.onPenMove(e);
        };
        /**
         * pen dot hover, v2.18
         * @param buf
         */
        this.process_6f_hovermove_v218 = (buf) => {
            /**
             *  0:  1 - header
             *
             *  1:  1 - cmd (0x6F)
             *  2:  2 - length
             *  4:  1 - delta time
             *
             *  8:  2 - x
             * 10:  2 - y
             * 12:  1 - float x
             * 13:  1 - float y
            */
            const timediff = buf[4];
            this.accTime(timediff);
            const force = 0;
            const dotX = intFromBytes(buf, 5, 2);
            const dotY = intFromBytes(buf, 7, 2);
            const dotFx = intFromBytes(buf, 9, 1);
            const dotFy = intFromBytes(buf, 10, 1);
            const x = dotX + dotFx / 100;
            const y = dotY + dotFy / 100;
            const e = makePenEvent(DeviceTypeEnum.PEN, PenCommEventEnum.PEN_MOVE_HOVER, { x, y, force, timediff, timeStamp: this.currentTime });
            this.penHandler.onHoverMove(e);
        };
        /**
         * NDAC Error, v2.12
         * @param buf
         */
        this.process_6d_ndacerror_v212 = (buf) => {
            /**
             *  0:  1 - header
             *
             *  1:  1 - cmd (0x6D)
             *  2:  2 - length
             *  4:  1 - event count
             *  5:  1 - delta time
             *
             *  6:  2 - force
             *  8:  1 - image brightness
             *  9:  1 - exposure time
             * 10:  1 - NDAC process time
             * 11:  2 - label count
             * 13:  1 - ndac error code
             * 14:  1 - class type (0:G3C6, 1:N3C6)
             * 15:  1 - error count (down부터 카운트, 초기화:0)
            */
            const timediff = buf[5];
            this.accTime(timediff);
            const force = intFromBytes(buf, 6, 2);
            const brightness = buf[8];
            const exposureTime = buf[9];
            const ndacProcessTime = buf[10];
            const labelCount = intFromBytes(buf, 11, 2);
            const ndacErrorCode = buf[13];
            const ndacClassType = buf[14];
            const continuousErrorCount = buf[15];
            const options = {
                timeStamp: this.currentTime,
                timediff,
                force,
                brightness,
                exposureTime,
                ndacProcessTime,
                labelCount,
                ndacErrorCode,
                ndacClassType,
                continuousErrorCount,
            };
            const e = makePenEvent(this.deviceInfo.deviceType, PenCommEventEnum.CODE_ERROR, options);
            this.penHandler.onNcodeError(e);
        };
        /**
         * response at pen configuration (ex. hover mode)
         * @param buf
         */
        this.process_85_config_response = (buf) => {
            /**
             *  0:  1 - header
             *
             *  1:  1 - cmd (0x85)
             *  2:  1 - error code
             *  3:  2 - length
             *  5:  1 - type
             *  6:  1 - result (0:success, 1:fail)
            */
            this.clearProtocolTimeout();
            // const error_code = buf[2];
            const type = buf[5];
            // const success = buf[6] === 0 ? "success" : "fail";
            // console.log(`    BT protocol response(0x85): ${type} ==> ${success}`);
            // 연결 중 상태에서 온 것이라면
            if (this._connectionTask.promise) {
                this.on_85_config_response_duringConnection(buf);
            }
        };
        this.requestOnlineStrokeOnConnection = () => {
            // const bufferArray = new Uint8Array([0xc0, 0x11, 0x02, 0x00, 0xff, 0xff, 0xc1]);
            // this.write(bufferArray);
            if (this.isNowConnecting) {
                this.setProtocolTimeout("    BT protocol #END -> request online data");
                this.reqOnlineData_11();
            }
            else {
                this.disconnect();
            }
        };
        /**
         * response, 실시간 필기 데이터 요청에 따른
         * @param buf
         */
        this.process_91_realtime_mode_response = (buf) => {
            /**
             *  0:  1 - header
             *
             *  1:  1 - cmd (0x91)
             *  2:  1 - error code
             *  3:  2 - length
            */
            const Errcode = buf[2];
            if (Errcode === 0) {
                console.log("    BT protocol response(realtime mode) <- You can write.");
                console.log("    Device info ");
                console.log("         modelName: " + this.deviceInfo.modelName);
                console.log("         protocolVer: " + this.deviceInfo.protocolVer / 100);
                console.log("         deviceType: " + this.deviceInfo.deviceType);
                let errorCode = 0;
                let infoMessage = "";
                // callback
                if (this.deviceInfo.protocolVer < 218) {
                    errorCode = 1;
                    infoMessage = `need to upgrade firmware greater than 2.18 (current version=${this.deviceInfo.protocolVer / 100})`;
                }
                // 연결 중인 상태라면 ON_CONNECTED를 생성, 2022/06/27
                if (this.isNowConnecting) {
                    // 여기서 connect()의 promise를 resolve, 2022/06/27
                    if (this.deviceInfo.protocolVer >= 218) {
                        this.setHoverMode(1); // enable hover
                    }
                    else {
                        this.clearProtocolTimeout();
                        this._connectionTask.resolve(true);
                        this._connectionTask = {};
                    }
                    // pen event 송출
                    window.setTimeout(() => {
                        const e = makePenEvent(this.deviceInfo.deviceType, PenCommEventEnum.ON_CONNECTED, { errorCode, infoMessage, timeStamp: this.currentTime });
                        this.penHandler.onConnected(e);
                        // set auto hover mode
                    }, 5);
                }
            }
            else {
                console.log("BT protocol #4 <- error : " + Errcode);
            }
        };
        this.onPenPasswordSetupResponse = (success) => {
            this.setTimeStamp((new Date()).getTime());
            const e = makePenEvent(this.deviceInfo.deviceType, PenCommEventEnum.ONFINISHEDOFFLINEDOWNLOAD, {
                timeStamp: this.currentTime,
                success
            });
            this.penHandler.onPasswordChanged(e);
        };
        // super();
        this.penCommBase = new PenCommBase(this);
        this.penHandler = penHandler;
        this.setTimeStamp(0);
        // this.initialStatus = {
        //   isPwLocked: false,
        //   retryLimit: 10,
        //   currentRetryCount: 0,
        //   penTime: 0,
        //   autoPowerOffTimeMinutes: 20,
        //   maxPressureValue: _defaultMaxPenPressureValue,
        //   storageUsagePercent: 0,
        //   autoPenCapOnOff: false,
        //   autoPowerOn: false,
        //   beepOn: false,
        //   hoverModeOn: false,
        //   batteryLevelPercent: 0,
        //   isSupportOfflineStore: false,
        //   pressureSensitivity: 0,
        //   usbMode: PenUsbMode.BULK,
        //   isPathSimplifyOn: false,
        //   btLocalName: "",
        //   isStoreErrorLogOn: false,
        // }
    }
    // 2022/06/27
    get isNowConnecting() { return (!!this._connectionTask.promise); }
    get strokeStartTime() {
        return this._strokeStartTime;
    }
    set strokeStartTime(value) {
        this._currentTime = value;
        this._strokeStartTime = value;
    }
    get currentTime() {
        return this._currentTime;
    }
    /**
     * CMD 0x02
     * @param passcode
     */
    sendPasscode(passcode) {
        console.log("    BT protocol #3 -> input passcode ");
        this.reqPassword_02(passcode);
        // const bufferArray = new Uint8Array([
        //   PEN_PACKET_START,
        //   Cmd.PASSWORD_REQUEST, // 0x02,
        //   0x10, 0x00, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        //   PEN_PACKET_END
        // ]);
        // bufferArray[4] = passcode.charCodeAt(0);
        // bufferArray[5] = passcode.charCodeAt(1);
        // bufferArray[6] = passcode.charCodeAt(2);
        // bufferArray[7] = passcode.charCodeAt(3);
        // // g_btWriteSocket.writeValue(bufferArray);
        // this.write(bufferArray);
    }
}
export { deviceSelectDlg };
//# sourceMappingURL=pencomm.js.map